export const formatDubaiTime = (date, opts = {}) => {
  if (date === null || date === undefined || date === "") return "—";
  // Backend timestamps without a timezone (e.g. "2026-05-19 10:04:38") are UTC —
  // normalise to an ISO instant so the Dubai conversion is correct.
  const normalized =
    typeof date === "string" && !date.includes("T")
      ? `${date.replace(" ", "T")}Z`
      : date;
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return String(date);
  return d.toLocaleString("en-GB", { timeZone: "Asia/Dubai", ...opts });
};
